module.exports = __webpack_public_path__ + "static/media/CCF.641d0768.jpg";